<template>
  <div>
      <div class="ly-card order">
          <div class="nav_car">
              <div class="car">咨询师管理 &nbsp;&nbsp;&gt;&nbsp;&nbsp;咨询师详情</div>
              <div class="car"><span>姓名:&nbsp;{{ detailData.PSYCHIATRIST_NAME }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>等级:&nbsp;{{ detailData.PSYCHIATRIST_TITLE }}</span></div>
              <el-button class="car_btn" type="primary" @click="goBack()">返回</el-button>
          </div>
          <div class="detail_content">
              <div class="order_title">基本信息</div>
              <div>
                   <table class="detail_table">
                    <tr>
                        <td class="td_min">姓名</td>
                        <td class="td_max">{{ detailData.PSYCHIATRIST_NAME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">联系方式</td>
                        <td class="td_max">{{ detailData.MOBILE }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">咨询师等级</td>
                        <td class="td_max">{{ detailData.PSYCHIATRIST_TITLE }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">教育背景</td>
                        <td class="td_max">{{ getEducational(detailData.EDUCATIONAL_BACKGROUND) }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">地区</td>
                        <td class="td_max">{{ detailData.AREA_NAME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">持证年限</td>
                        <td class="td_max">{{ detailData.CERTIFICATE_HOLDING_PERIOD }}年</td>
                    </tr>
                    <tr>
                        <td class="td_min">擅长领域</td>
                        <td class="td_max">
                            <span v-for="(item,index) in detailData.RealmList" :key='item.REALM_ID' style="padding-right:10px;">{{ index+1 }}、{{ item.REALM_NAME }}</span>
                        </td>
                    </tr>
                </table>
              </div>
          </div>
          <!-- 证件展示 -->
          <div class="detail_content">
              <div class="order_title">个人相册</div>
              <div class="demo-image__preview">
                <el-image 
                    class="ly-Photo"
                    v-for="(item, index) in detailData.PhotoList"
                    :key="index"
                    style="width: 100px; height: 100px"
                    :src="imgUrl+item.PHOTO_IMG_ARTWORK" 
                    :preview-src-list="photoList"
                    >
                </el-image>
            </div>
          </div>
          <div class="detail_content">
              <div class="order_title">培训经历</div>
                <div class="experience">
                    <el-timeline>
                        <el-timeline-item
                            color="#ccc"
                            v-for="(activity, index) in detailData.TrainList"
                            :key="index"
                            :timestamp="handleTime(activity)">
                            {{activity.TRAINING_CONTENT}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
          </div>
          <div class="detail_content">
              <div class="order_title">个人介绍</div>
              <div class="introduce">
                {{ detailData.PERSONAL_PROFILE }}  
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            psychiatristId: 0,
            detailData: {},
            photoList: [],
            activeName: "first",
            imgUrl: this.$imgUrl, //图片地址
        }
    },
    mounted() {
         this.psychiatristId = this.$route.query.psychiatristID
        // 获取详情信息
        this.GetPsychiatDetail()
    },
    methods: {
        // 返回上一页
        goBack() {
             this.$router.back();
        },
        handleTime(item) {
            let time = item.START_TIME.slice(0,7) + '~' + item.END_TIME.slice(0,7)
            return time
        },
        // 教育背景转换
        getEducational(item) {
            let obj = {
                0: '未知',1: '不识字或识字很少',2:'小学',
                3:'初中',4: '高中或中专或职高',5:'大专',
                6:'本科',7:'硕士以上'
            }
            return obj[item]
        },
        // 咨询师详情
        GetPsychiatDetail() {
            this.$axios.post(`counselingApiSvr/Counseling/GetPsychiatristInfoDetail`,{
                psychiatristId: this.psychiatristId
            }).then(res =>{
                if (res.code == 200 || res.code == 0) {
                    if(res.data) {
                        this.detailData = res.data
                        if(res.data.PhotoList.length>0) {
                            let array = res.data.PhotoList
                            this.photoList = []
                            array.forEach(item => {
                                if(item.PHOTO_IMG_ARTWORK) {
                                    this.photoList.push(this.$imgUrl+item.PHOTO_IMG_ARTWORK)
                                }
                            })
                        }
                    }
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
 .order {
   height: 846px;
   overflow: auto;
   .detail_content {
        border: 2px solid #f2f2f2;
        margin-bottom: 20px;
        border-radius: 10px;
        .order_title {
            font-weight: 700;
            font-style: normal;
            color: #171C49;
            padding: 0 30px;
            line-height: 45px;
            background-color:rgba(242, 242, 242, 1);
            height: 45px;
            margin-bottom: 10px;
        }
        .introduce {
            width: 85%;
            margin: 40px 0 40px 80px;
            border-radius: 10px;
            min-height: 200px;
            border: 1px solid #f0f0f0;
            padding: 16px;
            color: #999;
            line-height: 30px;
        }
    }
    .el-step {
        height: 100px;
    }
    .detail_table {
        margin: 40px 0 40px 80px;
        min-width: 500px;
        border-collapse: collapse;
        border-spacing: 0px;
        border: none;
        font-size: 16px;
        font-weight: 400;
        font-family: "微软雅黑 Regular";
        text-align: center;
        tr {
            height: 30px;
            font-size: 16px;
            font-weight: 400;
            text-align: left;
            font-family: "微软雅黑 Regular";
            
        }
        td {
            border: 1px solid #e4e4e4;
            height: 35px;
            padding-left: 30px;
            font-size: 12px;
            color: #171C49;
        }
        .td_min {
            min-width: 150px;
        }
        .td_max {
            min-width: 500px;
        }
    }
}
.experience {
    padding: 40px 80px;
}
.nav_car {
    display: flex;
    min-height: 80px;
    align-items: center;
    .car {
        height: 40px;
        padding: 0 30px;
        line-height: 40px;
        text-align: center;
        box-shadow: 0px 0px 20px #00000059;
        border-radius: 10px;
        margin-right: 10px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        font-size: 14px;
    }
    .car_btn {
        border-radius: 10px;
        box-shadow: 0px 0px 20px #00000059;
    }
}
.ly-Photo {

    width: 200px !important;
    height: 50px;
    margin: 5px 20px;
}

.certificate-img {
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/consult/consultDetail.vue